import { useContext } from 'react'
import { TableContext } from './TableProvider'

const useTable = () => useContext(TableContext)

export default useTable
